import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import LoginPage from './pages/LoginPage';
import RegistroPage from './pages/RegistroPage';
import AutoevaluacionesPage from './pages/AutoevaluacionesPage';
import NuevaAutoevaluacion from './pages/NuevaAutoevaluacionPage';
import CuestionarioPage from './pages/CuestionarioPage';
import DashboardResultados from './pages/DashboardResultadosPage';
import AdminDashboard from './pages/AdminDashboardPage';
import AdminPreguntas from './pages/AdminPreguntas';
import AdminProcesos from './pages/AdminProcesos';
import AdminUsers from './pages/AdminUsers';
import Politica from './pages/Politica';
import ConfirmPage from './pages/ConfirmPage';
import '@fortawesome/fontawesome-free/css/all.min.css';
import PropuestasMejora from './pages/PropuestasMejoraPage';
import ScrollToTop from './components/ScrollToTop';
import AuthProvider from './authContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InstruccionesPage from './pages/InstruccionesPage';
import Sidebar from './components/Sidebar';
import DetalleEvaluacionPage from './pages/DetalleEvaluacionPage';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { getAuthToken } from "./utils/session";


const RequireAdmin = ({ children }) => {
  const token = getAuthToken();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  try {
    const decoded = jwtDecode(token);
    if (decoded.role !== 'ROLE_ADMIN') {
      return <Navigate to="/mis-autoevaluaciones" replace />;
    }
    return children;
  } catch (error) {
    Cookies.remove('token');
    Cookies.remove('userId');
    return <Navigate to="/login" replace />;
  }
};

const AppContent = () => {
  const location = useLocation(); // Obtener la ruta actual
  const [sidebarWidth, setSidebarWidth] = useState(0);

  // Mostrar Navbar solo en Home ("/") y Política ("/politica")
  const showNavbar = location.pathname === '/' || location.pathname === '/politica';
  
  // Mostrar Sidebar en todas menos Home, Login y Registro
const showSidebar = !showNavbar &&
  location.pathname !== '/login' &&
  location.pathname !== '/register' &&
  !location.pathname.startsWith('/reset-password/') &&
  location.pathname !== '/forgot-password';

  // Mostrar Footer solo en Home, Login, Registro y Política
  const showFooter = location.pathname === '/' || location.pathname === '/login' || 
                     location.pathname === '/register' || location.pathname === '/politica';

  const mainWidth = showSidebar ? `calc(100vw - ${sidebarWidth}px)` : '100vw';

  return (
    <>
      <ToastContainer />
      {showNavbar && <Navbar />}
      <ScrollToTop />
      <div
        className={showSidebar ? 'dqpa-app-shell dqpa-app-shell--with-sidebar' : 'dqpa-app-shell'}
        style={{ display: 'flex', minHeight: '100vh', width: '100vw', overflowX: 'hidden' }}
      >
        {/* Sidebar solo cuando corresponde */}
        {showSidebar && <Sidebar onWidthChange={setSidebarWidth} />}

        {/* Contenido Principal */}
        <main
          className="dqpa-app-main"
          style={{
            flex: '1 1 auto',
            minWidth: 0,
            width: mainWidth,
            maxWidth: mainWidth,
            overflowX: 'hidden',
            transition: 'width 220ms ease, max-width 220ms ease',
          }}
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/politica" element={<Politica />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegistroPage />} />
            <Route path="/autoevaluaciones" element={<AutoevaluacionesPage />} />
            <Route path="/mis-autoevaluaciones" element={<AutoevaluacionesPage />} />
            <Route path="/nueva-autoevaluacion" element={<NuevaAutoevaluacion />} />
            <Route path="/cuestionario/:cuestionarioId" element={<CuestionarioPage />} />
            <Route path="/resultados/:cuestionarioId" element={<DashboardResultados />} />
            <Route path="/propuestas-mejora/:cuestionarioId" element={<PropuestasMejora />} />
            <Route path="/admin-dashboard" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
            <Route path="/admin-dashboard/preguntas" element={<RequireAdmin><AdminPreguntas /></RequireAdmin>} />
            <Route path="/admin-dashboard/procesos" element={<RequireAdmin><AdminProcesos /></RequireAdmin>} />
            <Route path="/admin-dashboard/usuarios" element={<RequireAdmin><AdminUsers /></RequireAdmin>} />
            <Route path="/confirm" element={<ConfirmPage />} />
            <Route path="/instrucciones/:cuestionarioId" element={<InstruccionesPage />} />
            <Route path="/detalle-evaluacion/:cuestionarioId" element={<DetalleEvaluacionPage />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
<Route path="/reset-password/:token" element={<ResetPassword />} />
          </Routes>
        </main>
      </div>

      {/* Mostrar el Footer solo en Home, Login, Register y Política */}
      {showFooter && <Footer />}
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
};

export default App;
